var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1 class=\"iq-headline\">Have you bought art from a gallery or auction house before?</h1><form class=\"iq-form stacked-button-menu\"><button type=\"submit\" name=\"collector_level\" value=\"3\" class=\"avant-garde-button-black js-iq-collector-level\">Yes</button><button type=\"submit\" name=\"collector_level\" value=\"2\" class=\"avant-garde-button-black js-iq-collector-level\">Not yet</button></form>");;return buf.join("");
};
module.exports = template;